var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "144px",
    viewBox: "0 0 120 144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VECTOR - time management") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VECTOR---time-management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69,108 C58,117 56,123 47,118 C39.1731831,113.651768 38.9327607,107.183834 46,101 C54,94 63,80 61,73 C59,66 46,64 37,59 C15.8867845,47.2704358 40,20 65.4399855,25.649993 C90.879971,31.2999861 91,50 93,64 C84.3333333,87.3333333 76.3333333,102 69,108 Z",
    id: "Blob",
    fill: "#FEF6E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sparks",
    transform: "translate(32.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spark",
    transform: "translate(0.000000, 44.000000)",
    fill: "#F7A600"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 6.22222222,
    y: 0,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-3",
    x: 6.22222222,
    y: 9.33333333,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 6.22222222,
    y: 6.22222222,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-2",
    x: 9.33333333,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    x: 0,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  })), /*#__PURE__*/React.createElement("g", {
    id: "Spark",
    transform: "translate(36.000000, 0.000000)",
    fill: "#F9D076"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 6.22222222,
    y: 0,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-3",
    x: 6.22222222,
    y: 9.33333333,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 6.22222222,
    y: 6.22222222,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-2",
    x: 9.33333333,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    x: 0,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  })), /*#__PURE__*/React.createElement("g", {
    id: "Spark",
    transform: "translate(39.000000, 62.000000)",
    fill: "#F9D076"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 6.22222222,
    y: 0,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-3",
    x: 6.22222222,
    y: 9.33333333,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 6.22222222,
    y: 6.22222222,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-2",
    x: 9.33333333,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    x: 0,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clock",
    transform: "translate(46.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 20,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,4 C29.3888407,4 37,11.6111593 37,21 C37,30.3888407 29.3888407,38 20,38 C10.6111593,38 3,30.3888407 3,21 C3,11.6111593 10.6111593,4 20,4 Z M20,6 C11.7157288,6 5,12.7157288 5,21 C5,29.2842712 11.7157288,36 20,36 C28.2842712,36 35,29.2842712 35,21 C35,12.7157288 28.2842712,6 20,6 Z M26.3452365,1.24845569 L29.9704677,2.93892874 L29.1252311,4.75154431 L27.9797694,4.21745569 L26.8354102,6.50623059 L25.4937694,5.8354102 L26.6197694,3.58245569 L25.5,3.06107126 L26.3452365,1.24845569 Z M17,0 L23,0 L23,3 L22,3 L21,5 L19,5 L18,3 L17,3 L17,0 Z",
    id: "Oval",
    fill: "#38627F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,18 C21.6568542,18 23,19.3431458 23,21 C23,22.6568542 21.6568542,24 20,24 C18.3431458,24 17,22.6568542 17,21 C17,19.3431458 18.3431458,18 20,18 Z M20,19.5 C19.1715729,19.5 18.5,20.1715729 18.5,21 C18.5,21.8284271 19.1715729,22.5 20,22.5 C20.8284271,22.5 21.5,21.8284271 21.5,21 C21.5,20.1715729 20.8284271,19.5 20,19.5 Z M21.4393398,23.5 L22.5,22.4393398 L28.5606602,28.5 L27.5,29.5606602 L21.4393398,23.5 Z",
    id: "Oval",
    fill: "#C80000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C9D4DB",
    x: 5,
    y: 20,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C9D4DB",
    x: 31,
    y: 19,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C9D4DB",
    x: 19,
    y: 6,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C9D4DB",
    x: 19,
    y: 32,
    width: 2,
    height: 4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/TimeIcon.9ae619834a76981c0a3992956de97b55.svg";
export { ForwardRef as ReactComponent };